
var React = require('react');


module.exports = React.createClass({

  render: function() {
	const today = new Date();
    return (
      <footer className="folink-footer">
        <div className="footer">
          <div style={ { 'color': '#333333', "opacity": "0.6", "float": "right" } }>
            © {today.getFullYear()} KROWD LTD.
          </div>
        </div>
      </footer>
      );
  },
  componentDidMount: function() {
    /*  var header = $('.navbar').height();
      $('footer').height(header);

      if (document.querySelector('.main_container') !== null) {
          var navbar_height = document.getElementsByClassName('navbar')[0].offsetHeight;
          var footer = document.getElementsByClassName('folink-footer')[0].offsetHeight;
          var pagecontent = document.getElementsByClassName('main_container')[0].offsetHeight;
          if(pagecontent < window.innerHeight){
              var container_height = window.innerHeight - footer  - navbar_height;
          }else{
              var container_height = pagecontent;
          }
          document.getElementById('content').setAttribute('style', 'height :'+ container_height + 'px');*/
  }
});




// WEBPACK FOOTER //
// ./src/components/Footer.js